import React from 'react';

export const SpinnerComponent = () => {
  return (
    <div className="spinner-container">
      <div id="loader">
        {/* <div id="box">
            <img className="logo-lawft" alt="logo" src={logo} />
          </div> */}
        <div className="logo">
          <img alt="lawft" src="/assets/svg/lawft-loading.svg" className="logo" />
        </div>
        <div id="shadow"></div>
      </div>
    </div>
  );
};
